import React from 'react';

type Props = {
  className?: string;
  fill?: string;
  width?: string;
  height?: string;
};

const SearchClose: React.FC<Props> = ({ className, fill = 'currentColor', width = '18', height = '18' }) => (
  <svg className={className} width={width} height={height} viewBox="0 0 24 24" fill="none">
    <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z" fill={fill} />
  </svg>
);

export default SearchClose;
